export default {
  createExamSubject: '/examSubject/create',
  getExamSubject: '/examSubject/getExamSubject',
  getSubjectsForAnExam: '/examSubject/getSubjectsForAnExam',
  getExamsForASubject: '/examSubject/getExamsForASubject',
  updateExamSubject: '/examSubject/update',
  deleteExamSubject: '/examSubject/delete'
}
